import { render } from "./DailyTotal.vue?vue&type=template&id=639b27c8"
import script from "./DailyTotal.vue?vue&type=script&lang=js"
export * from "./DailyTotal.vue?vue&type=script&lang=js"

import "./DailyTotal.vue?vue&type=style&index=0&id=639b27c8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__